module.exports = __webpack_public_path__ + "img/code-merge.c327c88f.svg";